import { createElement, memo } from 'react';

function Embeddable({ token }) {
  return createElement('em-beddable', { token });
}

export default memo(Embeddable);
